import app from 'flarum/forum/app';
import Notification from 'flarum/components/Notification';

export default class UserRoleRewardWaitAcceptNotification extends Notification {
  icon() {
    return '';
  }

  img() {
    return '';
  }

  href() {
    return '#';
  }

  content() {
    const notification = this.attrs.notification;
    let text = app.translator.trans('dl-optimization.forum.userRoleRewardWaitAccept_text');
    return text;

  }
}
